// ColorSwatch.tsx
import React from 'react';
import eventBus from '../../event_bus';

export type PoolColor = {
  displayColor: number;
  valueColor: number;
  name: string;
};

type ColorSwatchProps = {
  color: PoolColor;
  selectedColor: PoolColor | null;
  onSelect: (color: PoolColor) => void;
};

const ColorSwatch: React.FC<ColorSwatchProps> = ({ color, selectedColor, onSelect }) => {
  const isSelected = color === selectedColor;
  const borderColor = isSelected ? "border-blue-300" : "border-gray-300";
  
  const handleClick = () => {
    onSelect(color); // Call the passed onSelect function
  };

  return (
    <div 
      onClick={handleClick} 
      style={{ backgroundColor: `#${color.displayColor.toString(16).padStart(6, '0')}`, width: '30px', height: '30px' }} 
      className={`cursor-pointer transition-all  hover:border-4 hover:border-sky-500 rounded-3xl mx-1 ${borderColor} transition-duration-300`}
    >
    </div>
  );
};

export default ColorSwatch;
